module.exports = __webpack_public_path__ + "media/site_templates/www.paintersnearme.net.au/images/splash-c916cec1135b48ea0357c1c5bddac5a1.jpg";